<template>
  <div id="app">
    <router-view></router-view>
    <sideBar />
  </div>
</template>

<script>
  import sideBar from './components/SideBar.vue'
  export default {
    name: 'app',
    components: {
      sideBar,
    },
    data() {
      return {
        screenWidth: window.innerWidth,
        deviceType: '',
      }
    },
    mounted() {
      this.updateDeviceType()
      window.addEventListener('resize', this.updateDeviceType)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.updateDeviceType)
    },
    methods: {
      updateDeviceType() {
        this.screenWidth = window.innerWidth
        if (this.screenWidth <= 768) {
          this.deviceType = '手机或平板'
        } else {
          this.deviceType = '电脑'
        }
        // console.log(this.deviceType)
        // console.log(this.$store)
        this.$store.dispatch('setDeviceType', this.deviceType)
      },
    },
  }
</script>

<style lang="scss">
  @import './scss/main';
</style>
